import { render, staticRenderFns } from "./DashboardBusiness.vue?vue&type=template&id=8ed62964&"
import script from "./DashboardBusiness.vue?vue&type=script&lang=js&"
export * from "./DashboardBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBusiness.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports